import React, { useState, memo, useEffect } from "react";
import postApiCall from "../Services/postApiCall";
import { decryptBody, encryptData, decrypData } from "../Services/helpers";
import styles from "../css/login-page.module.css";
import PasswordInput from "../Utils/PasswordInput";
import { toast, ToastContainer } from "react-toastify";
import OtpInput from 'react-otp-input';
import "../css/login-page.module.css";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import ErrorPage from "../Pages/ErrorPage";
import { selectedPartnerDetails } from "../Services/authenticationService";
import { slugifyTransform, migrateSavedAllAccount } from "../Utils/Helpers";
import IsAuthenticat from "../IsAuthenticat";

function LoginPage({ modalKey, partnerDetails }) {
  const partnerDetailData= partnerDetails?.data;
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const [inputValue, setInputValue] = useState("");
  const [loginType, setLoginType] = useState("null"); // "phone" | "email"
  const [step, setStep] = useState("login"); // login | verify | forgot | forgot-verify
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [rePassword, setRePassword] = useState("");
  const [partnerUserId, setPartnerUserId] = useState("");
  const [isReady, setIsReady] = useState(true);
  const [error, setError] = useState({}); // inline validation errors
  const [timer, setTimer] = useState(30);
  const [canResend, setCanResend] = useState(false);
  const [resendOtp, setResendOtp] = useState(false)
  const [suggestions, setSuggestions] = useState([]);
  const [savedAccounts, setSavedAccounts] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("allAccounts") || "[]");
    } catch {
      return [];
    }
  });
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
  
   const redirectPath = sessionStorage.getItem("redirectAfterLogin") || "/home";
// utils/migrateSavedAccount.js

if(IsAuthenticat()){
  navigate(`/${slugifyTransform(selectedPartnerDetails()?.name)}/home`, { replace: true });
}
  const syncSavedAccounts = (nextAccounts) => {
    setSavedAccounts(nextAccounts);
    localStorage.setItem("allAccounts", JSON.stringify(nextAccounts));
  };

  const removeSavedAccount = (email) => {
    const filteredAccounts = savedAccounts.filter((acc) => acc.email !== email);
    syncSavedAccounts(filteredAccounts);
    setSuggestions((prev) => prev.filter((acc) => acc.email !== email));

    if (inputValue === email) {
      setInputValue("");
      setLoginType(null);
    }
  };

  const removeAllSavedAccounts = () => {
    syncSavedAccounts([]);
    setSuggestions([]);
    setInputValue("");
    setLoginType(null);
  };
  // detect login type
  const handleInputChange = (e) => {
    let val = e.target.value.trim();

    if (/^\d+$/.test(val)) {
      // allow only 10 digits for phone
      val = val.slice(0, 10);
      setLoginType("phone");
    } else if (/\S+@\S+\.\S+/.test(val)) {
      setLoginType("email");
    } else {
      setLoginType(null);
    }
 const matches = savedAccounts.filter((acc) =>
      acc.email.toLowerCase().includes(val.toLowerCase())
    );
    console.log('matches:::::',matches)
    setSuggestions(val ? matches : []);
    setInputValue(val);
  };
    console.log('suggestions:::::11111111',suggestions, IsAuthenticat())

   const selectSuggestion = (acc) => {
    setInputValue(acc.email);
    setPassword(decrypData(acc.password));
    setLoginType("email");
    setSuggestions([]);
  };
  useEffect(()=>{
migrateSavedAllAccount()
  },[])
  useEffect(() => {
    setInputValue("");
    setLoginType(null);
    setOtp("");
    setPassword("");
    setNewPassword("");
    setRePassword("");
    setPartnerUserId("");
    setError({});
    setStep('login')
  }, [modalKey]);
  // Send OTP or Continue (for email)
  const sendOtpOrContinue = async (e) => {
    e.preventDefault();
    setError({});
    if (!inputValue) return setError({ input: "Email or Phone is required" });
    if (!loginType) return setError({ input: "Enter valid email or phone" });
    if (!isReady) return;

    setIsReady(false);

    if (loginType === "email") {
      setStep("verify");
      setIsReady(true);
      return;
    }

    let obj = { type: 2, mobile: inputValue };
    try {
      const data = await postApiCall("admin/sendOTP", obj);
      if (data.meta.status) {
        const decryptUserId = decryptBody(data.data);
        console.log('decryptUserId:::::',decryptUserId)
        setPartnerUserId(decryptUserId.userId);
        toast.success(data.meta.msg);
        setStep("verify");
      } else {
        toast.error(data.meta.msg);
      }
    } catch (err) {
      console.log("Error:", err);

  const errorMessage =
    err?.response?.data?.meta?.msg || "Something went wrong!";

  toast.error(errorMessage);
    } finally {
      setIsReady(true);
    }
  };

  // Verify OTP or Password
  const verifyOtpOrPassword = async (e) => {
    e.preventDefault();
    setError({});
    let payload = { partnerUserId, type: loginType === "phone" ? 2 : 1, partnerId: partnerDetailData?._id };

    if (loginType === "phone") {
      if (!otp) return setError({ otp: "OTP is required" });
      payload.otp = otp;
      // payload.phone = inputValue
     }else {
  if (!password) {
    return setError({ password: "Password is required" });
  }

  if (!passwordRegex.test(password)) {
    return setError({
      password:
        "Password must be at least 8 characters, include uppercase, lowercase, number, and special character",
    });
  }

  payload = {
    ...payload,
    email: inputValue,
    password,
    partnerId: partnerDetailData?._id
  };

  delete payload.partnerUserId;

  try {
    const data = await postApiCall("admin/login", payload);

    if (data?.meta?.status) {
      const existing = savedAccounts.find((a) => a.email === inputValue && decrypData(a.password) === password);

    if (!existing) {
      const updated = [...savedAccounts, { email:inputValue, password: encryptData(password) }];
      syncSavedAccounts(updated);
    }
      // Never store password
      const { token, ...userData } = data.data;
      sessionStorage.removeItem("redirectAfterLogin");
      localStorage.setItem("loginDetails", token);
      localStorage.setItem("userDetails", JSON.stringify(userData));
      const filteredPartner  = userData?.partnerDetails.find((partner)=>partner._id===userData.partnerId);
      console.log(';filteredPartner::::',filteredPartner)
      localStorage.setItem("selectedPartner",JSON.stringify(filteredPartner?filteredPartner:userData?.partnerDetails[0]))

          // window.location.href = "/home";

// navigate(`${redirectPath}`, { replace: true });
// navigate(redirectPath, { replace: true });
window.location.href = `${slugifyTransform(filteredPartner?filteredPartner?.name:userData?.partnerDetails[0]?.name)+redirectPath}`;

          // navigate(from, { replace: true });
    } else {
      toast.error(data?.meta?.msg || "Login failed", {
        toastId: data?.meta?.msg || "login-failed",
      });
    }
  } catch (error) {
    console.error("Login API Error:", error);

    toast.error(
      error?.response?.data?.meta?.msg ||
        error?.message ||
        "Something went wrong. Please try again.",
      {
        toastId: "login-api-error",
      }
    );
  }

  return;
}
    //  else {
    //   if (!password) return setError({ password: "Password is required" });
    //   if (!passwordRegex.test(password)) {
    //     return setError({
    //       password:
    //         "Password must be at least 8 characters, include uppercase, lowercase, number, and special character",
    //     });
    //   }
    //  payload={
    //   ...payload,
    //   email:inputValue,
    //   password
    //  } 
    //   delete payload["partnerUserId"]
    //   const data = await postApiCall("admin/login", payload);
    //   if (data.meta.status) {
    //     // ✅ Never store password
    //     const { token, ...userData } = data.data;
    //     // ✅ Use localStorage for sensitive session data
    //     localStorage.setItem("loginDetails", token);
    //     localStorage.setItem("userDetails", JSON.stringify(userData));

    //     window.location.href = "/home";
    //   } else {
    //     toast.error(data.meta.msg,{ toastId: data.meta.msg });
    //   }
    //   return
    // }

    
    try {
      const data = await postApiCall("admin/verifyOTP", payload);
      if (data.meta.status) {
        // ✅ Never store password
        const { token, ...userData } = data.data;
        // ✅ Use localStorage for sensitive session data
        localStorage.setItem("loginDetails", token);
        localStorage.setItem("userDetails", JSON.stringify(userData));
        localStorage.setItem("selectedPartner",JSON.stringify(userData?.partnerDetails[0]))

        // window.location.href = "/home";
       window.location.href = `${slugifyTransform(userData?.partnerDetails[0].name)+redirectPath}`;
      } else {
        toast.error(data.meta.msg);
      }
    } catch {
      toast.error("Something went wrong!");
    }
  };

  // Forgot password flow
  const handleForgotPassword = async (e, type = "send") => {
    e.preventDefault();
    setError({});
    if (!inputValue) return setError({ input: "Email is required" });
    if (!/\S+@\S+\.\S+/.test(inputValue))
      return setError({ input: "Enter a valid email" });

    if (!newPassword) return setError({ newPassword: "New password required" });
    if (!passwordRegex.test(newPassword)) {
      return setError({
        newPassword:
          "New Password must be at least 8 characters, include uppercase, lowercase, number, and special character",
      });
    }
    if (!rePassword) return setError({ rePassword: "Please retype password" });
    if (newPassword !== rePassword)
      return setError({ rePassword: "Passwords do not match" });

    let obj = {
      email: inputValue,
      password: newPassword,
      confirmPassword: rePassword
    };
    try {
      const data = await postApiCall("admin/reset-password-otp", obj);
      if (data.meta.status) {
        if (type !== "resend") {
          setStep("forgot-verify");
        } else {
          setResendOtp(!resendOtp)
        }
        toast.success(data.meta.msg);
      } else {
        toast.error(data.meta.msg);
      }
    } catch {
      console.log('errrrr catchhhh::::')
      toast.error("Something went wrong!");
    }
  };

  const resetPassword = async (e) => {
    e.preventDefault();
    if (!otp) return setError({ otp: "OTP is required" });

    let payload = {
      email: inputValue,
      otp: Number(otp),
      password: newPassword,
    };

    try {
      const data = await postApiCall("admin/reset-password", payload);
      if (data.meta.status) {
        toast.success(data.meta.msg);
        // reset all state
        setStep("login");
        // setInputValue("");
        setPassword("");
        setNewPassword("");
        setRePassword("");
        setOtp("");
        setError({});
      } else {
        toast.error(data.meta.msg);
      }
    } catch {
      toast.error("Something went wrong!");
    }
  };

  const handleEditPhonEmail = () => {
    setStep("login");
    setPassword('')
    setNewPassword('')
    setRePassword('')
    setOtp('')
  }

  const formatMobile = (num) => {
  if (!num) return "";
  // Ensure it's only digits
  num = num.toString().replace(/\D/g, "");
  // Apply your pattern: XX-XX75-9723
  return `XX-XX${num.slice(4, 6)}-${num.slice(6)}`;
  };

const maskEmail = (email) => {
  if (!email) return "";
  const [user, domain] = email.split("@");
  // If username is shorter than 3 chars, show only first char
  const visible = user.slice(0, 3);
  return `${visible}***@${domain}`;
};




  useEffect(() => {
    if ((step === "verify" && loginType === "phone") || step === "forgot-verify") {
      setTimer(30);
      setCanResend(false);
      const interval = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            setCanResend(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [step, loginType, resendOtp]);


  return (
    <div className="container11">
      {partnerDetails?.meta?.status?(<>
      <div className={`row g-0 mx-0 my-0 ${styles["hide-scroll"]}`}>
        <div className={`col-sm-12 col-md-7 col-lg-7 ${styles["left-container"]}`}>
          {partnerDetailData?.logo?<img src={partnerDetailData.logo} alt="Logo" className="logo img-fluid"/>:<div style={{fontWeight:"bold",fontSize:"25px",color:"#242056"}}><span style={{ color: "#EA5817",fontWeight:"bold"}}>One</span> Home </div>}
          <div className={styles["info-container"]}>
            {!partnerDetailData?.title&&<p className={styles["text-1"]}>One Place Auction </p>}
            <h2 className={styles["text-2"]}>
              {partnerDetailData?.title? partnerDetailData.title : (<>Simplified <br /> Real Estate Auctions!</>)}
            </h2>
            <p className={styles["text-3"]}>
              {partnerDetailData.description?partnerDetailData.description:(<>
              Effortless Property Management!
              <br />
              Manage your real estate auctions seamlessly with our intuitive
              platform.
              </>)}
            </p>
          </div>
        </div>

        <div className={`${styles["card-container"]} col-sm-12 col-md-5 col-lg-5`}>
          <div className={styles["card-container"]}>
            {/* Login Step */}
            <div className="card-body">
               <div className={`${styles["login-logo"]} d-md-none mb-5`}>{partnerDetailData?.logo?<img src={partnerDetailData.logo} alt="Logo" className="logo img-fluid"/>:(<><span style={{ color: "#EA5817",fontWeight:"bold"}}>One</span> Home </>)}</div>
              {(step !== "forgot-verify" && step !== "forgot" && step !== "verify") ? (<>
                <h4 style={{ color: "#EA5817" ,marginBottom:"30px",fontWeight:"600",fontSize:"20px"}} className="d-none d-sm-block">Login</h4>
                <p style={{ color: "#263C7E", fontSize: "20px", marginBottom:"2px" }}>Welcome to {partnerDetailData.title || "OneHome"}</p>
                <p style={{ color: "#667085", fontSize: "14px" }} className="mb-5">Login to access your {partnerDetailData.title || "OneHome"} account</p>

              </>) : <div className="d-flex align-items-center mb-3">
                {/* Back button */}
                <button
                  type="button"
                  className="btn btn-link p-0 mb-2"
                  onClick={() => {
                    setStep("login");
                    setError({});
                    setNewPassword("");
                    setRePassword("");
                  }}
                >
                  <i className="bi bi-arrow-left" style={{ fontSize: "20px", color: "black" }}></i>
                </button>
                {/* <h4 style={{ color: "#EA5817" }}>Forgot Password</h4> */}
              </div>
              }
              {step === "login" && (
                <form onSubmit={sendOtpOrContinue} className={`${styles["form-container"]} mb-5`}>

                  <div className="form-group mb-3">
                    {/* <label style={{color:"#667085"}}>{loginType === "phone" ? "Phone Number" : (loginType === "email") ? "Email Address" : "Phone Number / Email ID for OTP"}</label> */}
                    <div className="input-group highlight-group mb-5">
                      {loginType === "phone" && (
                        <span className="input-group-text login-country-code ">+91</span>
                      )}
                      <input
                        type={loginType === "phone" ? "number" : "email"}
                        className="form-control"
                        placeholder="Enter Email ID / Mobile No."
                        value={inputValue}
                        maxLength={loginType === "phone" ? 10 : undefined}
                        onChange={handleInputChange}
                        required
                        autoFocus
                        autoComplete="email"
                      />
                    </div>
                    {error.input && <small className="text-danger">{error.input}</small>}
                    {suggestions.length > 0 && (
                      <div
                        style={{
                          position: "relative",
                          top: "-40px",
                          left: 0,
                          right: 0,
                          marginTop: "6px",
                          padding: "6px",
                          listStyle: "none",
                          background: "#fff",
                          borderRadius: "12px",
                          boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                          border: "1px solid #e5e7eb",
                          zIndex: 1000,
                          maxHeight: "220px",
                          overflowY: "auto",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "8px 10px 6px",
                            borderBottom: "1px solid #f3f4f6",
                            marginBottom: "4px",
                          }}
                        >
                          <span style={{ fontSize: "12px", color: "#6b7280", fontWeight: 600 }}>
                            Saved accounts
                          </span>
                          <button
                            type="button"
                            className="btn btn-link btn-sm p-0 text-danger"
                            style={{ fontSize: "12px", textDecoration: "none" }}
                            onClick={removeAllSavedAccounts}
                          >
                            Remove all
                          </button>
                        </div>
                        {suggestions.map((acc, i) => (
                          <div
                            key={i}
                            onClick={() => selectSuggestion(acc)}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              padding: "12px",
                              borderRadius: "8px",
                              cursor: "pointer",
                              transition: "all 0.2s ease",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.background = "#f8fafc";
                              e.currentTarget.style.transform = "translateX(4px)";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background = "transparent";
                              e.currentTarget.style.transform = "translateX(0)";
                            }}
                          >
                            <div
                              style={{
                                width: "36px",
                                height: "36px",
                                borderRadius: "50%",
                                background: "#242056",
                                color: "#fff",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontWeight: 600,
                                fontSize: "14px",
                                flexShrink: 0,
                              }}
                            >
                              {acc.email?.charAt(0)?.toUpperCase()}
                            </div>

                            <div style={{ overflow: "hidden", flex: 1 }}>
                              <div
                                style={{
                                  fontSize: "14px",
                                  fontWeight: 500,
                                  color: "#111827",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {acc.email}
                              </div>

                              <div
                                style={{
                                  fontSize: "12px",
                                  color: "#6b7280",
                                }}
                              >
                                Saved account
                              </div>
                            </div>

                            <button
                              type="button"
                              className="btn btn-link p-0 text-danger"
                              style={{ lineHeight: 1 }}
                              aria-label={`Remove ${acc.email}`}
                              onClick={(e) => {
                                e.stopPropagation();
                                removeSavedAccount(acc.email);
                              }}
                            >
                              <i className="bi bi-trash"></i>
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  <button className="btn btn-primary btn-block mt-2" type="submit">
                    {loginType === "phone" ? "Get OTP" : "Continue"}
                  </button>


                </form>
              )}

              {/* Verify Step */}
              {step === "verify" && (
                <form onSubmit={verifyOtpOrPassword} className={styles["form-container"]}>

                  {/* <label>{loginType === "phone" ? "Phone Number" : "Email"}</label>
                  <div className="d-flex align-items-center mb-2">
                    <input
                      className="form-control me-2 mr-1"
                      value={inputValue}
                      disabled={true}
                      onChange={(e) => setInputValue(e.target.value)}
                    />
                    <button
                      type="button"
                      className="btn btn-link p-0"
                      onClick={() => {
                        handleEditPhonEmail()
                      }}
                    >
                      <i className="bi bi-pencil" style={{ fontSize: "1.2rem", color: '#EF5713' }}></i>
                    </button>
                  </div> */}
                <h4 style={{ color: "#EA5817" ,marginBottom:"30px",fontWeight:"600",fontSize:"20px"}} className="d-none d-sm-block">Login</h4>
                <p style={{ color: "#263C7E", fontSize: "20px", marginBottom:"2px" }}>{loginType === "phone" ? "OTP Verification" : "Password Verification"}</p>
                <p style={{ color: "#667085", fontSize: "14px" }}> {loginType === "phone" ? `Please enter OTP sent to ${formatMobile(inputValue)}`: `${maskEmail(inputValue)}`}</p>
                  {loginType === "phone" ? (
                    <>
                      <label>Enter OTP</label>
                      {/* <input
                        type="text"
                        className="form-control"
                        placeholder="Enter OTP"
                        value={otp}
                        maxLength={6}
                        onChange={(e) => setOtp(e.target.value)}
                      /> */}
                      <OtpInput
                        value={otp}
                        onChange={setOtp}
                        numInputs={6}
                        containerStyle={styles.otpWrapper}
                        renderInput={(props,index) => (
                          <input
                            {...props}
                            className={styles.otpInput} 
                            autoFocus={index === 0}
                          />
                        )}
                      />



                      {error.otp && <small className="text-danger">{error.otp}</small>}

                      <div className="d-flex justify-content-between align-items-center mt-2">
                        {!canResend ? (
                          <small className="text-muted">Resend OTP in {timer}s</small>
                        ) : (
                          <button
                            type="button"
                            className="btn btn-link p-0"
                            onClick={async () => {
                              // 🔹 Call resend OTP API for login
                              let obj = { type: 2, mobile: inputValue };
                              try {
                                const data = await postApiCall("admin/sendOTP", obj);
                                if (data.meta.status) {
                                  toast.success(data.meta.msg);
                                  setResendOtp(!resendOtp)
                                } else {
                                  toast.error(data.meta.msg);
                                }
                              } catch {
                                toast.error("Something went wrong!");
                              }
                            }}
                          >
                            Resend OTP
                          </button>
                        )}
                      </div>
                    </>
                  ) : (
                    <>
                      <PasswordInput
                        placeholder="Enter Password"
                        // label="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        error={error.password || ''}
                      />
                      <div className="d-flex justify-content-end mb-5">
                        <button
                          type="button"
                          className="btn btn-link p-0"
                          onClick={() => setStep("forgot")}
                        >
                          Forgot Password?
                        </button>
                      </div>
                    </>
                  )}


                  <button className="btn btn-primary btn-block mt-3" type="submit">
                    {loginType === "phone" ? "Verify OTP" : "Login"}
                  </button>

                </form>
              )}

              {/* Forgot Password */}
              {step === "forgot" && (
                <form onSubmit={(e) => handleForgotPassword(e, 'send')} className={styles["form-container"]}>
                  <label>Email</label>
                  <input
                    className="form-control mb-2"
                    value={inputValue}
                    onChange={handleInputChange}
                  />
                  {error.input && <small className="text-danger">{error.input}</small>}
                  <PasswordInput
                    placeholder={"New Password"}
                    label="New Password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    error={error.newPassword || ''}
                  />
                  <PasswordInput
                    placeholder={'Re-Enter Password'}
                    label="Re-Enter Password"
                    value={rePassword}
                    onChange={(e) => setRePassword(e.target.value)}
                    error={error.rePassword || ''}
                  />

                  <button className="btn btn-primary btn-block mt-3" type="submit">
                    Send OTP
                  </button>
                </form>
              )}


              {/* Forgot Password Verify */}
              {step === "forgot-verify" && (
                <form onSubmit={resetPassword} className={styles["form-container"]}>
                  <label>Email</label>
                  <input className="form-control mb-2" value={inputValue} disabled />

                  <label>Enter OTP</label>
                  {/* <input
                    type="text"
                    className="form-control"
                    value={otp}
                    maxLength={6}
                    onChange={(e) => setOtp(e.target.value)}
                  /> */}
                  <OtpInput
                        value={otp}
                        onChange={setOtp}
                        numInputs={6}
                        containerStyle={styles.otpWrapper}
                        renderInput={(props) => (
                          <input
                            {...props}
                            className={styles.otpInput}   // ✅ Correct way
                          />
                        )}
                      />
                  {error.otp && <small className="text-danger">{error.otp}</small>}

                  <div className="d-flex justify-content-between align-items-center mt-2">
                    {!canResend ? (
                      <small className="text-muted">
                        Resend OTP in {timer}s
                      </small>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-link p-0"
                        onClick={async (e) => {
                          handleForgotPassword(e, 'resend')
                        }}
                      >
                        Resend OTP
                      </button>
                    )}
                  </div>

                  <button className="btn btn-primary btn-block mt-3" type="submit">
                    Reset Password
                  </button>
                </form>
              )}

            </div>
          </div>
        </div>
      </div>
      </>):<ErrorPage /> }
      <ToastContainer style={{top: '57px' }}/>
    </div>
  );
}

export default LoginPage;

